import GenericRequest, { METHOD_GET } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';
import RouterUtils from '../../../../../shared/routing/RouterUtils';

export default class MessageRequest extends GenericRequest {

    constructor(id) {
        super(METHOD_GET, RouterUtils.generateRoute(ApiEndpoints.MESSAGE_ID, { id: id }));
    }

}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/shared/ws/MessageRequest.js